import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-about',
  templateUrl: './cyclops-about.component.html',
  styleUrls: ['./cyclops-about.component.scss']
})
export class cyclopsAboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
